import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';

export const Schema = Yup.object().shape({

});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings  } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group className="mb-3" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>Wie wurden Sie auf die Stelle aufmerksam?</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.BecomingAwareThroughLawyers.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};